module.exports = __webpack_public_path__ + "img/step1-4.fe76c38c.png";